import http from 'apis/config/http-service';
import { useCallback } from 'react';
import type { MasterProductFamily } from './types';
import { masterProductFamiliesEndpoint } from './use-get-master-product-families-api';

// Search master product families for the Restaurant Inquiry item picker
// (ChakraAsyncSelect). Plain list endpoint with a `universalName` filter — the
// row narrows the picked family down to one variant client-side (see
// pages/inquiry-processor/utils/variant-elimination), so no exclusion params
// here: the same family may legitimately appear on several rows.
export interface MasterProductFamilyOption {
  value: number; // familyId
  label: string; // universalName
  raw: MasterProductFamily;
}

export function useSearchMasterProductFamiliesApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: MasterProductFamilyOption[]) => void) => {
    http
      .get(masterProductFamiliesEndpoint, {
        params: {
          page: 1,
          limit: 20,
          universalName: inputValue || undefined,
        },
      })
      .then(({ data }) => {
        const list: MasterProductFamily[] = data?.data ?? [];
        callback(list.map((f) => ({ value: f.id, label: f.universalName, raw: f })));
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
